module.exports = __webpack_public_path__ + "img/logo_carbo_brake.93e718fb.svg";